/* eslint-disable */

export const handleValidation = (inputFields) =>{
    let fields = inputFields;
    let errors = {};
    let individualInputErrors = {}
    let formIsValid = true;
    //Name
    if (!fields["bedNumber"]) {
      formIsValid = false;
      errors["bedNumber"] = "Cannot be empty";
      individualInputErrors["ipdNo"] = true
    }

    if (!fields["wardID"]) {
        formIsValid = false;
        errors["wardID"] = "Cannot be empty";
        individualInputErrors["wardID"] = true
      }
      if (!fields["roomTypeID"]) {
        formIsValid = false;
        errors["roomTypeID"] = "Cannot be empty";
        individualInputErrors["roomTypeID"] = true
      }
     
    if (!fields["bedStatus"]) {
      formIsValid = false;
      errors["bedStatus"] = "Cannot be empty";
      individualInputErrors["bedStatus"] = true
    }
    return {formIsValid, errors, individualInputErrors};
  }